// What a stop asks of the user before the tour will move on. Shared by both
// tours, so the context is whatever that tour's predicates read: the edit case
// tour passes formik values, easy mode passes its step validation.

export const evaluateRequirement = ({ requirement, ...context }) => {
   if (!requirement) {
      return { isBlocked: false, hint: null };
   }

   if (requirement.isSatisfied(context)) {
      return { isBlocked: false, hint: null };
   }

   const { hint } = requirement;

   // Easy mode's hints are the wizard's own validation messages, which change as
   // the user types, so a hint may be derived rather than written out
   return { isBlocked: true, hint: typeof hint === "function" ? hint(context) : hint };
};

// Whether the user may step past a stop they have not carried out. False where
// the wizard itself refuses to advance, since offering a skip that cannot work
// is worse than offering none
export const getCanSkipRequirement = (requirement) => requirement?.canSkip !== false;

export default evaluateRequirement;
